import Vue from 'vue'
const moment = require('moment')

// Last locale loade will be the default one
require('moment/locale/en-gb')
require('moment/locale/cs')

Vue.use(require('vue-moment'), { moment })
